// extracted by mini-css-extract-plugin
export default {"AssessmentQuestions":"styles_AssessmentQuestions__yHypq","addButton":"styles_addButton__tRU5T"};